export default __webpack_public_path__ + "static/media/04_photo.5ab8b638.jpg";